import { connect } from 'react-redux'

import { showTransientNotification } from '@driftt/traffic-control'
import SingleSegment from 'components/Segments/SingleSegment'
import {
  deselectMember,
  receiveSegmentDetails,
  receiveSegmentMembers,
  selectMember 
} from 'modules/segment_list/actions'

const mapStateToProps = state => ({
  orgId: state.user.orgId,
  segmentList: state.__CRM.segmentList.members,
  segment: state.__CRM.segmentList.segment,
  selectedMembers: state.__CRM.segmentList.selectedMembers
})

const mapDispatchToProps = dispatch => {
  return {
    onReceiveSegmentMembers: members => {
      dispatch(receiveSegmentMembers(members))
    },
    onReceiveSegmentDetails: details => {
      dispatch(receiveSegmentDetails(details))
    },
    onSelectMember: id => {
      dispatch(selectMember(id))
    },
    onDeselectMember: id => {
      dispatch(deselectMember(id))
    },
    showTransientNotification: config => {
      dispatch(showTransientNotification(config))
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SingleSegment)
